import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock';
import { helpers } 		from '../helpers.js';

var modal = {
	selectors: {
		element: '[data-modal]',
		trigger: '[data-modal-trigger]',
		close: '[data-modal-close]',
		activeInner: {}, 
	},
	init: function () {
		var self = this;

		self.trigger();
		self.close();
		self.timer();
	},
	isExpired: function( element ) {
		if( ! element.attr( 'modal-timeframe' ) ) return false;

		var dates = element.attr( 'modal-timeframe' ).split( '/' );

		var d = new Date();
		var month = d.getMonth()+1;
		var day = d.getDate();
		var currentDate = d.getFullYear() + ( month < 10 ? '0' : '' ) + month + ( day < 10 ? '0' : '')  + day;

		if( currentDate < dates[0] || currentDate > dates[1] ) {
			return true;
		}

		return false;
	},
	userSeenModal: function( slug ) {
		if( helpers.getCookie( slug ) ) {
			return true;
		}

		return false;
	},
	timer: function() {
		var self = this;

		if( ! jQuery( '.modal__inner' ).length ) return;

		jQuery( '.modal__inner' ).each( function() {
			var viewModal = true;
			var modalSlug = 'modal--' + jQuery( this ).attr( 'modal-slug' );
			var modalCookies = jQuery( this ).attr( 'modal-cookies' );
			// check for timeframe first ... if not valid, delete ...

			if( self.isExpired( jQuery( this ) ) ) viewModal = false;
			if( self.userSeenModal( modalSlug ) ) viewModal = false;

			if( jQuery( this ).attr( 'modal-view' ) && viewModal ) {
				var thisModal 	= jQuery( this );
				var slug 		= thisModal.attr( 'modal-slug' );
				var seconds 	= parseInt( jQuery( this ).attr( 'modal-view' ) );
				
				// set cookie
				helpers.setCookie( modalSlug, 1, modalCookies );

				if( seconds == 0 ) {
					self.triggerVritual( slug );
				}

				if( seconds >= 1 ) {
					setTimeout( function() {
						self.triggerVritual( slug );
					}, seconds * 1000 );
				}
			}
		});
	},
	triggerVritual: function( slug ) {
		jQuery( '.virtual-trigger' ).attr( 'data-modal-trigger', slug );
		jQuery( '.virtual-trigger' ).trigger( 'click' );
	},
	trigger: function (){
		var self = this;

		jQuery(document.body).on('click', self.selectors.trigger, function (event) {
			event.preventDefault();

			var $this = jQuery(this);
			var findInner = $this.attr('data-modal-trigger');
			var inner = document.querySelector('.modal__inner--' + findInner);

			jQuery('.modal__inner.inner-active').removeClass('inner-active');
			
			setTimeout(() => {
				inner.classList.add('inner-active');

				self.selectors.activeInner = inner;
				document.querySelector('.modal__content').classList.add(findInner);

				disableBodyScroll(self.selectors.activeInner, {
					reserveScrollBarGap: true,
				});
				
				jQuery(document.body).addClass('modal-opened');
			}, 20);

			setTimeout(function () {
				$this.blur();
				jQuery(document.body).focus();
			}, 150);

			return false;
		});
	},
	close: function() {
		var self = this;

		jQuery(self.selectors.element).on('click', self.selectors.close, function (e) {
			e.preventDefault();

			enableBodyScroll(self.selectors.activeInner);
			clearAllBodyScrollLocks();

			jQuery(document.body).removeClass('modal-opened');
			jQuery('.inner-active').removeClass('inner-active');

			jQuery('.modal__content').attr('class', 'modal__content');

			self.selectors.activeInner = {};

			return false;
		});
	}
};

export { modal };
